<template>
  <base-modal :id="id" :ok-button-text="okButtonText" :cancel-button-text="cancelButtonText">
    <p>{{ body }}</p>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';

export default {
  name: 'GenericModal',
  components: { BaseModal },
  props: {
    id: {
      type: String,
      default: 'generic-modal',
    },
    title: {
      type: String,
      default: 'Modal title',
    },
    body: {
      type: String,
      default: 'Modal Body'
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    }
  },
}
</script>
